import FourOhFourImage from "assets/404.svg";
import ButtonLink from "core/components/ButtonLink";
import { Row } from "core/styles";
import { useNavigate } from "react-router";

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      data-test="error-page"
      style={{
        height: "100%",
        width: "80%",
        margin: "0px auto",
        padding: "18vh 0px 15vh",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        gap: "30px",
      }}
    >
      <img
        src={FourOhFourImage}
        alt="404 page"
        style={{
          display: "block",
          width: "78%",
          margin: "0px auto",
        }}
      />

      <span
        style={{
          textAlign: "center",
          fontSize: "32px",
          fontWeight: "400",
          color: "var(--color-base-content)",
          maxWidth: "854px",
        }}
      >
        Looks like the page you’re looking for is no longer here or may have
        moved.
      </span>

      <Row>
        <ButtonLink
          variant="outlined"
          to="/"
          onClick={() =>
            window.open(
              "https://success.populi.ai/hc/en-us",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Contact Support
        </ButtonLink>
        <ButtonLink to="/" onClick={() => navigate("/")}>
          Return Home
        </ButtonLink>
      </Row>
    </div>
  );
};

export default PageNotFound;
